import { createTheme } from '@mui/material';
import { components } from './components';
import { themeConfig } from './themeConfig';

export const theme = createTheme({
  typography: {
    fontFamily: themeConfig.typography.fontFamily,
    allVariants: {
      color: themeConfig.colors.primary.main
    },
    h1: themeConfig.typography.sizes.h1,
    h2: {
      ...themeConfig.typography.sizes.h2,
      fontWeight: 'normal'
    },
    h3: {
      ...themeConfig.typography.sizes.h3,
      fontWeight: 'bold'
    },
    subtitle1: {
      ...themeConfig.typography.sizes.subtitle1,
      fontWeight: 'bold'
    },
    subtitle2: {
      ...themeConfig.typography.sizes.subtitle2,
      fontWeight: 'bold'
    },
    body1: themeConfig.typography.sizes.body1,
    body2: themeConfig.typography.sizes.body2,
    button: {
      ...themeConfig.typography.sizes.button,
      fontWeight: 'bold',
      textTransform: 'unset'
    },
    caption: themeConfig.typography.sizes.caption
  },
  palette: {
    mode: 'light',
    primary: {
      ...themeConfig.colors.primary,
      contrastText: '#ffffff'
    },
    secondary: {
      ...themeConfig.colors.secondary,
      contrastText: '#ffffff'
    },
    grey: themeConfig.colors.grey,
    success: {
      ...themeConfig.colors.success,
      contrastText: '#ffffff'
    },
    error: themeConfig.colors.error,
    info: {
      ...themeConfig.colors.info,
      contrastText: '#ffffff'
    },
    warning: {
      ...themeConfig.colors.warning,
      contrastText: '#ffffff'
    },
    neutral: {
      ...themeConfig.colors.neutral,
      contrastText: '#ffffff'
    },
    background: {
      paper: '#FFFFFF',
      default: '#ECEFF5'
    },
    mint: {
      ...themeConfig.colors.mint,
      contrastText: '#ffffff'
    },
    heaven: {
      dark: themeConfig.colors.heaven[700],
      main: themeConfig.colors.heaven[600],
      light: themeConfig.colors.heaven[500],
      ...themeConfig.colors.heaven,
      contrastText: '#ffffff'
    }
  },
  components
});
